import selectorBasicActionsFor from './basicActionsFor'
import fetchReducerFor, { fetchInitialState, FetchState } from '../fetch/reducerFor'
import { isResourceSelectedAction, isResourcesSelectedAction, SelectorAction } from './model'

export type SelectorState<T> = FetchState<T[]> & {
  selected?: T
  selectedResources?: T[]
}

export const selectorInitialState = {
  ...fetchInitialState,
  selected: undefined
}

function selectorReducerFor<T>(resourceName: string, prefix?: string, origin?: string) {
  if (resourceName == null) throw new Error('fetchReducerFor: Expected resourceName')

  const actionTypes = selectorBasicActionsFor(resourceName, prefix)
  const fetchReducerForOrigin = fetchReducerFor<T[]>(resourceName, prefix, origin)

  return function reducer(state: SelectorState<T> = selectorInitialState, action: SelectorAction<T>): SelectorState<T> {
    if (action.origin !== origin) return {...state}

    state = {
      ...state,
      ...fetchReducerForOrigin(state, action)
    }

    switch (action.type) {
      case actionTypes.resourceSelected:
        if (isResourceSelectedAction(action)) return {...state, selected: action.payload.selected}
        return {...state}

      case actionTypes.resourcesSelected:
        if (isResourcesSelectedAction(action)) return {...state, selectedResources: action.payload.resources}
        return {...state}

      default:
        return {...state}
    }
  }
}

export default selectorReducerFor
